import { generateSeoProps } from '../generateSeoProps';
export const getContactUsSeoProps = () => {
	return generateSeoProps({
		title: 'Pharmuni | Contact Us',
		description: 'Get in touch with Pharmuni for any inquiries or support.',
		canonical: 'contact-us'
	});
};
